import React from "react";
import type { StorefrontConfig, TrustStripConfig } from "@/src/types/storefront";
import { BADGE_ICON_SVGS } from "./TrustStrip";

type Badge = NonNullable<TrustStripConfig["badges"]>[number];

/** The seller's home-page "key highlights" (trust strip badges), if they set any. */
export function storeHighlights(
  storefront?: StorefrontConfig | null,
  list: "badges" | "cartBadges" = "badges",
): Badge[] {
  const strip = storefront?.sections?.find((s) => s.type === "trustStrip");
  const badges = (strip?.config as TrustStripConfig | undefined)?.[list] ?? [];
  return badges.filter((b) => b.title?.trim() || b.sub?.trim());
}

const DEFAULT_ICONS = ["truck", "refresh", "shield"];

interface Props {
  /** Seller's key highlights; empty → the GrabLocal defaults below. */
  badges?: Badge[];
  minCartValue?: number | null;
}

/** The three-up highlights under Add to cart on product and combo pages. */
export function ProductHighlights({ badges = [], minCartValue }: Props) {
  const items = badges.length
    ? badges.slice(0, 3).map((b, i) => ({ label: b.title, sub: b.sub, icon: b.icon || DEFAULT_ICONS[i] }))
    : [
        { label: "Free Delivery", sub: minCartValue ? `Orders above ₹${minCartValue.toLocaleString("en-IN")}` : "On every order", icon: "truck" },
        { label: "Easy Returns", sub: "7-day return policy", icon: "refresh" },
        { label: "Quality Assured", sub: "Vetted by GrabLocal", icon: "shield" },
      ];

  return (
    <div className="grid grid-cols-3 gap-2 border-t border-[#F0EDE6] pt-4">
      {items.map(({ icon, label, sub }, i) => (
        <div key={i} className="flex flex-col items-center gap-1.5 text-center">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl text-[#F26250] [&>svg]:h-[17px] [&>svg]:w-[17px]" style={{ background: "#FEF0EC" }}>
            {BADGE_ICON_SVGS[icon] ?? BADGE_ICON_SVGS.check}
          </span>
          <p className="text-[11.5px] font-semibold text-[#1D1D1D] leading-tight">{label}</p>
          <p className="text-[10.5px] text-[#8A8A85] leading-tight">{sub}</p>
        </div>
      ))}
    </div>
  );
}
